export enum OnboardingSteps {
  PERSONAL_INFO = 1,
  COMPANY_INFO = 2,
  INVESTING_INTEREST = 3
}
